var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-img',{attrs:{"width":"100%","src":_vm.image}},[_c('div',{staticClass:"title-box"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.titleText)}}),_c('div',{staticClass:"h2-foreground"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.text)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }